import styled from '@emotion/styled';

import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

interface ContainerProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {}

export const Container: React.FC<ContainerProps> = ({ className, children }) => {
  return <Wrapper className={className}>{children}</Wrapper>;
};

const Wrapper = styled.div`
  height: 100%;
  padding-top: 40px;
  padding-right: 40px;
  padding-left: 40px;
  position: relative;
  display: grid;
  margin: 0 auto;
  max-width: var(--breakpoints-xl);

  ${getMediaqueryStyled('xl')} {
    max-width: var(--breakpoints-lg);
  }

  ${getMediaqueryStyled('lg')} {
    padding-top: 25px;
    padding-right: 25px;
    padding-left: 25px;
    max-width: var(--breakpoints-md);
  }

  ${getMediaqueryStyled('md')} {
    padding-top: 0;
    padding-right: 44px;
    padding-left: 44px;
    max-width: 650px;
  }

  ${getMediaqueryStyled('sm')} {
    padding-top: 0;
    padding-right: 38px;
    padding-left: 38px;
    max-width: none;
  }
`;
